var module = angular.module('octopusApp.infrastructure');

module.directive('loadingWrapper', function (focus, $timeout) {
    return {
        restrict: 'E',
        replace: false,
        transclude: true,
        scope: {
            busy: '='
        },
        templateUrl: 'infrastructure/directives/views/loading-wrapper.html',
        link: function ($scope, element) {
            $scope.hasLoaded = false;
            $scope.once = (element.attr('once') || 'false').toLocaleLowerCase() === 'true';

            $scope.$watch("busy.busy", function() {
                if ($scope.hasLoaded && $scope.once){
                    return;
                }


                focus("page-loaded");

                $scope.hasLoaded = !$scope.busy.busy;
                if ($scope.hasLoaded && $scope.once) {
                    $timeout(function () {
                        $(".fade-in-when-loaded", element).removeClass("fade-in-when-loaded");
                    }, 200);
                }
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/loading_wrapper.js
// module id = 667
// module chunks = 1